import { useSyncExternalStore } from 'react'

export type Teilnehmersicht = { aktiv: boolean; fehlversuche: number }

export const MAX_FEHLVERSUCHE = 3

const KEY = 'admination.teilnehmersicht'
const RUHE: Teilnehmersicht = { aktiv: false, fehlversuche: 0 }
const listeners = new Set<() => void>()
let stand: Teilnehmersicht = lesen()

function lesen(): Teilnehmersicht {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return RUHE
    const parsed: unknown = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return RUHE
    const { aktiv, fehlversuche } = parsed as Record<string, unknown>
    return { aktiv: aktiv === true, fehlversuche: typeof fehlversuche === 'number' ? fehlversuche : 0 }
  } catch {
    return RUHE
  }
}

function schreiben(next: Teilnehmersicht): void {
  stand = next
  try {
    if (next.aktiv) localStorage.setItem(KEY, JSON.stringify(next))
    else localStorage.removeItem(KEY)
  } catch (error) { void error }
  for (const listener of listeners) listener()
}

export function teilnehmersichtStarten(): void {
  schreiben({ aktiv: true, fehlversuche: 0 })
}

export function teilnehmersichtBeenden(): void {
  schreiben(RUHE)
}

export function fehlversuchZaehlen(): void {
  schreiben({ aktiv: true, fehlversuche: stand.fehlversuche + 1 })
}

export function entsperren(): void {
  schreiben({ aktiv: true, fehlversuche: 0 })
}

export function useTeilnehmersicht(): Teilnehmersicht {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    () => stand,
  )
}
